import { PropsWithChildren } from 'react'

export function TabPanel({ show, children }: PropsWithChildren<{ show: boolean }>) {
  if (!show) {
    return <></>
  }

  return <>{children}</>
}